<template>
    <div class="link-list">
        <h2 class="link-list--title" v-if="content.title" v-text="content.title"></h2>

        <ul class="u-reset link-list--items">
            <li class="link-list--item"
                    v-if="content.links"
                    v-for="(link, linkIdx) in content.links" :key="linkIdx">
                <a class="u-reset link-list--link" v-bind="linkAttrs(link)">
                    <span class="link-list--link-content">
                        <span class="link-list--link-text" v-text="link.label"></span>
                        <cmp-icon v-if="link.external" class="link-list--link-icon"
                                symbol="external" size="small">
                        </cmp-icon>
                    </span>
                </a>
            </li>
        </ul>

        <!-- <pre v-if="content" v-text="content"></pre> -->
    </div>
</template>

<script>
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';


    const EXTERNAL_LINK_ATTRS = Object.freeze({
        target: '_blank',
        rel: 'noopener noreferrer',
    });

    export default {
        mixins: [
            cmsPluginMixin,
        ],
        methods: {
            linkAttrs({ path, external }) {
                return {
                    href: path,
                    ...(external ? EXTERNAL_LINK_ATTRS : {}),
                };
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/link-list/index.vue?985c0f88